<h1>DE CIFRIS MODCRYPTO26: CRITTOGRAFIA MODERNA 2026</h1>
<div class="toptext">
    <p>
        Organizzato a <b>Roma</b> dall'Associazione Nazionale di Crittografia <b>"De Componendis Cifris"</b>,
        il corso si svolge in due parti.
    </p>
    <p>
        <b>Prima parte:</b> "Introduzione alla crittografia moderna" — 8-12 giugno 2026<br>
        <b>Seconda parte:</b> "Crittografia Avanzata" — 14-18 settembre 2026
    </p>

    <div class="image-container" style="text-align: center;">
        <img mat-card-image src="../../../../assets/images/icons/decifris.svg" style="height: 70px;">
    </div>
</div>

<h2>INFORMAZIONI GENERALI </h2>
<div class="text">
    <h3>Didattica</h3>
    <p>
        <b>Modalità:</b> Frontale, in presenza.<br>
        <b>Orari:</b> 9:00–13:00 presentazione, 14:00–17:00 sessione sperimentale.
    </p>

    <h3>Iscrizioni</h3>
    <p>
        Il corso è riservato ai Soci di <b>De Cifris</b>
        (<a href="https://www.decifris.it/associazione/associarsi">Diventa socio</a>).
        Le richieste di iscrizione devono pervenire entro il <b>18 maggio 2026</b>.
        La frequenza permetterà il rilascio di un attestato di partecipazione.
    </p>
    <p>
        <b>Quota di partecipazione:</b> €2.000 per l'intero corso, €1.500 per la partecipazione a una sola settimana.
    </p>
    <p>
        <b> Le iscrizioni al corso sono concluse per esaurimento dei posti disponibili.</b>
    </p>
    <p>
        <b>Locandina:</b> (<a href="https://drive.google.com/file/d/1MbCSyrGarrXN_yDSLy7o3QolL_2QpWkI" target="_blank">link</a>)<br>
        <b>Contatti:</b> <a href="mailto:formazione@decifris.it">formazione&#64;decifris.it</a>
    </p>
</div>

<h2>PROGRAMMA</h2>

<h3>Parte 1: Introduzione alla crittografia moderna (8–12 giugno 2026)</h3>
<div class="row">
    <div class="col-md-12" style="margin-right:5% !important">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" style="width: 10%;"> Giorno </th>
                    <th scope="col" style="width: 90%;"> Argomento </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row"> DAY 1 </th>
                    <td>
                        <b>Introduzione e prerequisiti</b><br>
                        Recap di base sulla matematica (Euclide, aritmetica modulare, gruppi, curve ellittiche),
                        nozioni introduttive di crittografia: obiettivi (confidenzialità, integrità, autenticazione),
                        scenari di attacco, modelli di attaccanti.
                    </td>
                </tr>
                <tr>
                    <th scope="row"> DAY 2 </th>
                    <td>
                        <b>Crittografia a chiave pubblica classica – logaritmo discreto</b><br>
                        Logaritmo discreto e scambio di chiavi Diffie-Hellman (su campi e curve ellittiche),
                        metodi di attacco per collisione del logaritmo discreto.
                    </td>
                </tr>
                <tr>
                    <th scope="row"> DAY 3 </th>
                    <td>
                        <b>Crittografia a chiave pubblica classica – proprietà</b><br>
                        Definizione e formalizzazione di crittosistema a chiave pubblica e nozioni di sicurezza,
                        il crittosistema RSA e il problema della fattorizzazione, attacchi classici a RSA,
                        malleabilità e cifratura omomorfa, RSA-OAEP, cifratura randomizzata,
                        crittosistema di El-Gamal, nozioni di sicurezza: CPA, CCA, IND-CPA, IND-CCA.
                    </td>
                </tr>
                <tr>
                    <th scope="row"> DAY 4 </th>
                    <td>
                        <b>Crittografia a chiave privata – cifrari a blocchi</b><br>
                        Formalizzazione di crittosistema a chiave privata, SPN e reti di Feistel,
                        descrizione e analisi di cifrari classici: AES, DES, PRESENT, GOST.
                    </td>
                </tr>
                <tr>
                    <th scope="row"> DAY 5 </th>
                    <td>
                        <b>Crittografia a chiave privata – funzioni hash</b><br>
                        Funzioni di hash: costruzione MD e sponge, resistenza alle collisioni,
                        costruzioni applicative: modi d'uso di un cifrario a blocchi, cifratura autenticata.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<h3>Parte 2: Crittografia avanzata (14–18 settembre 2026)</h3>
<div class="row">
    <div class="col-md-12" style="margin-right:5% !important">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" style="width: 10%;"> Giorno </th>
                    <th scope="col" style="width: 90%;"> Argomento </th>
                </tr>
            </thead>
            <tbody>
    <tr>
        <th scope="row"> DAY 1 </th>
        <td>
            <b>Crittografia post quantum</b><br>
            Cenni sull'algoritmo di Shor, introduzioni a problemi PQ secure,
            crittosistemi a chiave pubblica PQ standard NIST.
        </td>
    </tr>
    <tr>
        <th scope="row"> DAY 2 </th>
        <td>
            <b>Firme digitali classiche e PQ</b><br>
            Firme digitali, protocolli di autenticazione, zero knowledge proof,
            firme digitali da zero knowledge proof (approccio classico e post quantum).
        </td>
    </tr>
    <tr>
        <th scope="row"> DAY 3 </th>
        <td>
            <b>Protocolli crittografici standard</b><br>
            Protocolli di comunicazione: IPsec/IKE, TLS, PGP, Signal protocol.
        </td>
    </tr>
    <tr>
        <th scope="row"> DAY 4 </th>
        <td>
            <b>Encryption with Advanced Functionalities</b><br>
            Fully-homomorphic encryption, identity-based encryption, attribute-based encryption.
        </td>
    </tr>
    <tr>
        <th scope="row"> DAY 5 </th>
        <td>
            <b>Multi-Party Computation</b><br>
            Coin tossing, oblivious transfer, garbled circuits, MPC-in-the-head.
        </td>
    </tr>
</tbody>
        </table>
    </div>
</div>

<h2>INFORMAZIONI PER GLI ISCRITTI</h2>
<div class="text">
    <p>
        Per qualsiasi domanda relativa al corso, scrivere a
        <a href="mailto:formazione@decifris.it">formazione&#64;decifris.it</a>.
    </p>
</div>